// extracted by mini-css-extract-plugin
export default {"staleContentWarning":"CommentBox-module__staleContentWarning__z4g6go7","commentBoxContainer":"CommentBox-module__commentBoxContainer__cDH_iX5"};